// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

/*
 *
 * ----------------------------------------------- */
var swiper = new Swiper(".swiper-simple", {
  allowTouchMove: false,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  direction: "vertical",
  on: {
    reachEnd: function () {
      setTimeout(function () {
        jQuery(
          ".navbar-default, .section-copyright, .section-fv .btn-container"
        ).fadeIn();
      }, 2600);

      setTimeout(function () {
        jQuery(".icon-arrow-down").fadeIn();
      }, 3000);
    },
  },
});

/*
 *
 * ----------------------------------------------- */
swiper.on("slideChange", function () {
  if (swiper.realIndex === 0) {
    setTimeout(function () {
      $("#text-fluffy-1").addClass("active");
    }, 2000);

    setTimeout(function () {
      $("#text-fluffy-2").addClass("active");
    }, 2200);

    setTimeout(function () {
      $("#text-fluffy-3").addClass("active");
    }, 2400);

    setTimeout(function () {
      $("#text-fluffy-4").addClass("active");
    }, 2800);
  }
});

/*
 *
 * ----------------------------------------------- */
// new Swiper(".swiper-container-nonstop-slide .swiper-container", {
//   observer: true,
//   observeParents: true,
//   slidesPerView: "auto",
//   centeredSlides: true,
//   spaceBetween: 25,
//   initialSlide: 2,
//   loop: true,
//   speed: 7500,
//   allowTouchMove: false,
//   autoplay: {
//     enabled: true,
//     delay: 1,
//   },
//   breakpoints: {
//     767: {
//       spaceBetween: 30,
//     },
//   },
// });
